import { render, staticRenderFns } from "./parcelasNaoDescontadas.vue?vue&type=template&id=4b868dbf"
import script from "./parcelasNaoDescontadas.vue?vue&type=script&lang=js"
export * from "./parcelasNaoDescontadas.vue?vue&type=script&lang=js"
import style0 from "./parcelasNaoDescontadas.vue?vue&type=style&index=0&id=4b868dbf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports